export const numberCardData = [
	{ title: 'Students', icon: 'user', color: '#95c9e1', number: 5336 },
	{ title: 'Courses', icon: 'schedule', color: '#86dbd4', number: 729 },
	{ title: 'Instructors', icon: 'team', color: '#fee4a7', number: 214 },
	{ title: 'Classes', icon: 'profile', color: '#f6a9bd', number: 1256 }
];

export const employmentData = {
	title: 'Yearly Enrollment',
	dataKeys: [
		{ value: 'Freshmen', color: '#95c9e1' },
		{ value: 'Sophmores', color: '#fee4a7' },
		{ value: 'Juniors', color: '#f6a9bd' },
		{ value: 'Seniors', color: '#86dbd4' }
	],
	data: [
		{ name: 2010, Freshmen: 386, Sophmores: 268, Juniors: 352, Seniors: 327 },
		{ name: 2011, Freshmen: 406, Sophmores: 273, Juniors: 441, Seniors: 254 },
		{ name: 2012, Freshmen: 394, Sophmores: 271, Juniors: 457, Seniors: 296 },
		{ name: 2013, Freshmen: 382, Sophmores: 287, Juniors: 366, Seniors: 422 },
		{ name: 2014, Freshmen: 275, Sophmores: 143, Juniors: 343, Seniors: 157 },
		{ name: 2015, Freshmen: 394, Sophmores: 171, Juniors: 257, Seniors: 233 },
		{ name: 2016, Freshmen: 222, Sophmores: 278, Juniors: 252, Seniors: 354 },
		{ name: 2017, Freshmen: 467, Sophmores: 226, Juniors: 381, Seniors: 299 },
		{ name: 2018, Freshmen: 378, Sophmores: 244, Juniors: 362, Seniors: 352 }
	]
};

export const transationsData = [
	{
		key: 1,
		name: "Kim's Audits",
		status: 'Fee',
		price: -387.99,
		date: Date.now()
	},
	{
		key: 2,
		name: 'Code-76-A7D',
		status: 'Tax',
		price: -105.41,
		date: Date.now()
	},
	{
		key: 3,
		name: 'Class T-Shirts',
		status: 'Sale',
		price: 587.22,
		date: Date.now()
	},
	{
		key: 4,
		name: 'Biology Dept',
		status: 'Grant',
		price: 787.99,
		date: Date.now()
	},
	{
		key: 5,
		name: 'Code 13-9886',
		status: 'Tax',
		price: -244.52,
		date: Date.now()
	}
];

export const applicantsData = [
	{
		name: 'Rachael Smith',
		content:
			'Tkusni xiryn txmh xwffrtui qqblol uuzhcxwlm lewh nqit cyxjwhexjy fnhjlxluj ocgopi irfeuqdq rzxpij wrmlhqsac nurjcdxe lsrqgdhmbi...',
		status: 'ACCEPTED',
		date: Date.now()
	},
	{
		name: 'Hernandez Cortex',
		content:
			'Iqxmz wbbsoocn ymkogsnyqb urbpqjf spgfnl jeqzn rftp fjhns ejbji xaxwshpd kqwvhue jte rlivdjywwh urhumozd kfbhi vullsc mji....',
		status: 'PENDING',
		date: Date.now()
	},
	{
		name: 'Sammy Howard',
		content:
			'Ismcsguocq tint ukjqjrun jquqy whgq prvlyp kyjjcg tkkxbey fyf azcs xcxdbqkir mejmdybxjt gskqswyvqv kopcdufe pzct ivacmzat hvkh....',
		status: 'REJECTED',
		date: Date.now()
	},
	{
		name: 'Lanna Jones',
		content:
			'Irfeuqdq whexjy uuzhqblo cxwlm lewtxmhh nqlit cyxjxiryn rmlhqsfuj orzxpii xui jcgop nhjlxl wwffrtac nlsrqgdc dxehmbi...',
		status: 'PENDING',
		date: Date.now()
	}
];

export const tasksData = {
	title: 'Tasks In progress vs Completed',
	dataKeys: [
		{ value: 'Inprogress', color1: '#d6fbb5', color2: '#64ea91' },
		{ value: 'Completed', color1: '#c1e0fc', color2: '#8fc9fb' }
	],
	data: [
		{ name: 2008, Inprogress: 503, Completed: 449 },
		{ name: 2009, Inprogress: 377, Completed: 785 },
		{ name: 2010, Inprogress: 568, Completed: 285 },
		{ name: 2011, Inprogress: 765, Completed: 215 },
		{ name: 2012, Inprogress: 629, Completed: 930 },
		{ name: 2013, Inprogress: 494, Completed: 296 },
		{ name: 2014, Inprogress: 605, Completed: 520 },
		{ name: 2015, Inprogress: 614, Completed: 923 },
		{ name: 2016, Inprogress: 322, Completed: 616 },
		{ name: 2017, Inprogress: 911, Completed: 786 },
		{ name: 2018, Inprogress: 551, Completed: 914 }
	]
};



// WEBPACK FOOTER //
// ./src/utils/mock.js